module.exports = __webpack_public_path__ + "static/media/start_collage.e45c16c8.png";